import { hasChild, localRead } from "@/libs/util";
import Main from "@/components/main";
import { forEach } from "@/libs/tools";
// 加载菜单
export const loadMenu = () => {
  let list = [];
  let data = localRead("route");
  if (!data) {
    return list;
  }
  list = formatMenu(JSON.parse(data));
  return list;
};

// 格式化菜单
export const formatMenu = list => {
  let res = [];
  forEach(list, item => {
    let obj = {};
    if (item.redirect) {
      obj = {
        path: item.path,
        name: item.name,
        redirect: item.redirect
      };
    } else {
      obj = {
        path: item.path,
        name: item.name
      };
    }
    obj.meta = item.meta;
    if (item.pid === 0) {
      obj.component = Main;
    } else {
      let data = item.component;
      obj.component = () => import("@/view" + data);
    }
    if (hasChild(item)) {
      obj.children = formatMenu(item.children);
    }
    res.push(obj);
  });
  return res;
};
